<style scoped>
.active {
  opacity: 0.5;
}
.margin-bottom {
  margin-bottom: 1rem;
}
</style>

<template>
  <mu-container v-if="flagFetchedChannel">
    <h2>
      <mu-button icon small @click="onClickBack"><mu-icon value="keyboard_backspace" /></mu-button>
      {{$t('AnalyticsMain.title')}} - {{channel.name}}
    </h2>
    <mu-row gutter>
      <mu-col span="12" sm="12" md="12" lg="3" xl="3">
        <mu-paper :z-depth="1" class="margin-bottom">
          <mu-list>
            <mu-list-item :button="$route.name !== nav.to.name" :ripple="false" v-for="nav in navs" :to="nav.to" :class="$route.name === nav.to.name ? 'active' : ''">
              <mu-list-item-action>
                <mu-icon :value="nav.icon"></mu-icon>
              </mu-list-item-action>
              <mu-list-item-title>{{nav.title}}</mu-list-item-title>
            </mu-list-item>
          </mu-list>
        </mu-paper>
      </mu-col>
      <mu-col span="12" sm="12" md="12" lg="9" xl="9" v-if="flagFetchedChannel">
        <router-view :channel="channel"/>
      </mu-col>
    </mu-row>
  </mu-container>
</template>

<script>
import langEn from './lang/en.json'
import langZh from './lang/zh.json'

// Library
import axios from "axios";

export default {
  name: "AnalyticsMain",
  props: {
    channelId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    // Object
    channel: {},

    // Flag
    flagFetchedChannel: false, // Boolean variable for status of channel fetched
  }),
  computed: {
    navs() {
      return [
        {
          title: this.$t('AnalyticsMain.nav.home'),
          icon: 'home',
          to: {
            name: 'AnalyticsHome',
            params: {
              channelId: this.channelId
            }
          }
        },
        {
          title: this.$t('AnalyticsMain.nav.channel'),
          icon: 'bar_chart',
          to: {
            name: 'AnalyticsChannel',
            params: {
              channelId: this.channelId
            }
          }
        },
        {
          title: this.$t('AnalyticsMain.nav.student'),
          icon: 'assignment_ind',
          to: {
            name: 'AnalyticsStudent',
            params: {
              channelId: this.channelId
            }
          }
        },
        {
          title: this.$t('AnalyticsMain.nav.export'),
          icon: 'get_app',
          to: {
            name: 'AnalyticsExport',
            params: {
              channelId: this.channelId
            }
          }
        },
      ]
    }
  },
  components: {
    
  },
  watch: {
    channelId: function() {
      this.checkPermit();
    }
  },
  created() {
    this.$i18n.add('en', langEn); // Add English Translation
    this.$i18n.add('zh', langZh); // Add Traditional Chinese Translation
    this.checkPermit();
  },
  methods: {
    checkPermit: function() {
      axios.get(this.$store.getters.urlApi + "permit/channel/" + this.channelId, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        var result = response.data.data.result;
        if(result) {
          this.fetchChannel();
        } else {

          this.$router.push({
            name: 'Home'
          });
        }
      });
    },
    fetchChannel: function() {
      axios.get(this.$store.getters.urlApi + "channel/" + this.channelId + '?all=1', {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.channel = response.data.data.channel;
        this.flagFetchedChannel = true;
      });
    },
    onClickBack() {
      this.$router.push({
        name: 'Channel',
        params: {
          channelId: this.channelId
        }
      });
    },
  },
};
</script>
